import Parse from "parse";

export async function saveProfileImage(base64Image) {
  const parseFile = await new Parse.File("avatarProfileImage.jpg", {
    base64: base64Image
  }).save();
  return parseFile.toJSON();
}

export async function createAvatar(payload) {
  const avatar = await Parse.Cloud.run("createAvatar", payload);
  if (avatar.profileImageFile) {
    avatar.profileImageFile = avatar.profileImageFile.toJSON();
  }
  delete avatar.user;
  return avatar;
}
export async function updateAvatar(payload) {
  const avatar = await Parse.Cloud.run("updateAvatar", payload);
  if (avatar.profileImageFile) {
    avatar.profileImageFile = avatar.profileImageFile.toJSON();
  }
  delete avatar.user;
  return avatar;
}
export function deleteAvatar(avatarId) {
  return Parse.Cloud.run("deleteAvatar", { avatarId });
}
export async function getAvatars() {
  const parseAvatars = await Parse.Cloud.run("getAvatars");
  const avatars = parseAvatars.map((parseAvatar) => {
    const avatar = parseAvatar.toJSON();
    if (avatar.birthDate) {
      avatar.birthDate = avatar.birthDate.iso;
    }
    delete avatar.user;
    return avatar;
  });

  return avatars;
}
